<!-- ; else isPN -->
<!-- <ng-container *ngIf="isPJ">
  <h3 class="ibk-title ibk-title--blue">Cuenta Negocios Plan Digital</h3>

  <ul class="check-list">
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Comisión por mantenimiento <br />
        <b class="f-bold">Costo Cero</b> <br />
        <b class="f-bold">Por los primeros meses</b>
        <div class="clarification">
          Se mantiene si realizas por lo menos una operación con tus cuentas Negocios a través de cualquier canal en el
          mes. Costo regular: S/50 o $15 por cliente
        </div>
      </span>
    </li>
  </ul>
  <ul class="check-list">
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Depósitos libres de costo <strong>ilimitados</strong><br />
        <b class="f-bold">En cajeros Global Net y Agentes interbank</b>
      </span>
    </li>
  </ul>

  <ul class="check-list">
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Operaciones distintas de depósitos libres de costos <br />
        <b class="f-bold">6 al mes</b> <br />
        <b class="f-bold">En cajeros Global Net</b>
      </span>
    </li>
  </ul>

  <ng-container *ngIf="showPlanDetails">
    <ul class="check-list">
      <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
          Banca por Internet <br />
          <b class="f-bold">Nivel Negocio Gratis***</b>
        </span>
      </li>
    </ul>
    <ul class="check-list">
      <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
          Tarjeta de débito Cuenta Negocios<br />
          <b class="f-bold">Gratis</b>
        </span>
      </li>
    </ul>

    <span>** Costos por operación en exceso: S./12.00 en tiendas Interbank y S./2.00 en cajeros Global Net</span> <br />
    <span>*** Aplica sólo para clientes Cuenta Negocio de la Banca Pequeña Empresa (con ventas anuales hasta S/3
      millones)
      que contraten la banca por Internet Empresas por primera vez
    </span>
  </ng-container>

  <button (click)="onPlanDetailsClick()"
    class="ibk-btn ibk-btn--primary ibk-btn--no-bg ibk-btn--borderless ibk-btn--medium-font toggler"
    id="view-more-plan-details">
    {{ !showPlanDetails ? "Ver" : "Ocultar" }} detalle del plan
    <ibk-icon class="icon" [class.icon--rotated]="showPlanDetails"> expand_more </ibk-icon>
  </button>

  <hr class="ibk-separator" />
</ng-container> -->

<!-- <ng-template #isPN>
  <h3 class="ibk-title ibk-title--blue">Cuenta Negocios Plan Digital</h3>

  <ul class="check-list">
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Comisión por mantenimiento <br />
        <b class="f-bold">Costo Cero</b>
      </span>
    </li>
  </ul>
  <ul class="check-list">
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Depósitos gratis en cajeros Global Net y agentes Interbank <b class="f-bold">Ilimitados</b>
      </span>
    </li>
  </ul>
  <ul class="check-list">
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Tarjeta de débito <br />
        <b class="f-bold">*Gratis</b> <br>
        <div class="clarification">Por la primera emisión</div>
      </span>
    </li>
  </ul>
  <ul class="check-list" *ngIf="showPlanDetails">
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Banca por Internet personas <br />
        <b class="f-bold">Gratis</b>
      </span>
    </li>
  </ul>
  <ul class="check-list">
    <li class="check-list__item" *ngIf="showPlanDetails">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Tasa de Rendimiento Efectivo Anual (TREA) <br />
        <b class="f-bold">0.00%</b>
      </span>
    </li>
  </ul>
  <ul class="check-list" *ngIf="showPlanDetails">
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Estado de cuenta digital <br />
        <b class="f-bold">Gratis</b>
      </span>
    </li>
  </ul>


  <button (click)="onPlanDetailsClick()"
    class="ibk-btn ibk-btn--primary ibk-btn--no-bg ibk-btn--borderless ibk-btn--medium-font toggler"
    id="view-more-plan-details">
    {{ !showPlanDetails ? "Ver" : "Ocultar" }} detalle del plan
    <ibk-icon class="icon" [class.icon--rotated]="showPlanDetails"> expand_more </ibk-icon>
  </button>

  <hr class="ibk-separator" />
</ng-template> -->

<h1 class="ibk-title text-center">{{!isPJ?'Configura tu cuenta':'Configuraci&oacute;n de la cuenta'}}</h1>
<div class="ctn-account">
  <section class="checkbox-group w-70" *ngIf="!isPJ">
    <b class="color-secondary fs-20"> ¿Cuenta en soles o dólares? </b>
    <br />
    <br />
    <ul *ngIf="showItemAccountBusiness" class="check-list">
      <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content"><b>¡Elige ambas!</b> y aprovecha el mejor tipo de cambio para tu
          negocio.</span><br />
      </li>
    </ul>
  </section>
  <section class="checkbox-group w-70" *ngIf="isPJ">
    <b class="color-secondary fs-20"> Aprovecha al m&aacute;ximo tu Cuenta Negocios, <b class="text-bold">¡&Aacute;brela
        en soles y d&oacute;lares!</b> </b>
    <br />
    <br />
    <ul *ngIf="showItemAccountBusiness" class="check-list">
      <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">El mejor tipo de cambio preferencial para tu negocio.</span><br />
      </li>
      <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">Disfruta el 2x1 en el costo de revisi&oacute;n de poderes, ¡Ahorra en tu segunda
          cuenta!</span><br />
      </li>
    </ul>
  </section>
  <div class="w-30 m-b ctn-img-money-pen-usd">
    <div class="centered">
      <img class="img-money-pen-usd" [src]="asset('assets/images/account-soles-dollars.svg')"
        alt="account soles dollars">
    </div>
  </div>
</div>
<!-- <h3 class="ibk-title ibk-title--blue">¿Cuenta en soles o dólares?</h3>
<br />
<br />

<p class="description"><b>¡Elige ambas!</b> y aprovecha el mejor tipo de cambio para tu negocio.</p> -->
<hr class="ibk-separator" />
<ng-container formGroupName="configData">
  <div class="currency-picker">
    <div>
      <h3 class="ibk-title text-bold">Elige la moneda(s) de tu cuenta</h3>
      <div class="currency-selector">
        <ibk-selector dsRxForm="selectorChange" formControlName="currency" class="currency-selector">
          <ibk-selector-option *ngFor="let option of currency$ | async" [value]="option.value"
            [label]="option.label"></ibk-selector-option>
        </ibk-selector>
      </div>
    </div>
  </div>
</ng-container>

<section class="checkbox-group your-business-account p-t-35">
  <b [class]=" isPJ?'b-title color-primary m-25':'b-title color-primary'" class="b-title color-primary"> Tu Cuenta
    Negocio </b>
  <br />
  <br />
  <ul *ngIf="!isPJ" class="check-list">
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Banca por Internet <span class="text-bold">Gratis</span><br />
      </span>
    </li>
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Comisi&oacute;n por mantenimiento <span class="text-bold">Costo cero</span><br />
      </span>
    </li>
    <li class="check-list__item">
      <ibk-icon class="bullet">check</ibk-icon>
      <span class="content">
        Operaciones gratis en cajeros Global Net** <span class="text-bold">6</span> ** S/ 7.00 o $ 2.50 por
        operaci&oacute;n extra<br />
      </span>
    </li>
  </ul>
  <ba-view-business-account-details *ngIf="!showItemAccountBusiness && !isPJ"></ba-view-business-account-details>
  <a *ngIf="!isPJ" href="#" [ngClass]="showItemAccountBusiness?'ibk-link collapsible':'ibk-link collapsible-active'"
    (click)="evtYourBusinessAccountPN($event)"><span class="text-bold">{{titleViewDetails}}</span></a>

  <div class="div-card" *ngIf="isPJ">
    <h2>
      Mantenimiento mensual
    </h2>
    <hr class="ibk-separator" />
    <p class="ibk-description">
      Sin costo
    </p>
    <p class="ibk-description">
      Te damos 2 meses sin costo en mantenimiento, al 3er mes se mantendr&aacute; siempre que realices por lo menos una
      transacción con alguna de tus Cuentas Negocios a travez de cualquier canal durante el mes. De lo contrario, se
      har&aacute; el cargo de S/ 50.00 o $15.00 en el mes de no transacci&oacute;n.
    </p>
    <span class="color-primary underlined">Ver tarifario</span>
  </div>
  <div class="div-card" *ngIf="isPJ">
    <h2>
      Banca por Internet para Empresas
    </h2>
    <hr class="ibk-separator" />
    <p class="ibk-description">
      Nivel negocio GRATIS**
    </p>
  </div>
  <div class="div-card" *ngIf="isPJ">
    <h2>
      Dep&oacute;sitos en canales f&iacute;sicos
    </h2>
    <hr class="ibk-separator" />
    <ul class="ibk-description ml">
      <li>
        <p class="ibk-description">
          Dep&oacute;sitos ilimitados sin costo en cajeros y agentes.<br />
        </p>
      </li>
      <li>
        <p class="ibk-description">
          Tienes hasta 10 dep&oacute;sitos por mes en tiendas sin costo***<br />
        </p>
      </li>
    </ul>
  </div>
  <div class="div-card" *ngIf="isPJ">
    <h2>
      Revisi&oacute;n de poderes legales
    </h2>
    <hr class="ibk-separator" />
    <p class="ibk-description">
      s/ 75 soles o s/ 25 soles (costo &uacute;nico)
    </p>
  </div>
  <div class="m-25" *ngIf="isPJ">
    <p class="ibk-description">
      ** Aplica solo para clientes Cuenta Negocio de la Banca Pequeña Empresa que contraten la Banca por Internet por
      primera vez.
    </p>
    <p class="ibk-description">
      *** Costos por operaci&oacute;n extra: S/ 12.00 en tienda y S/ 2.00 en ATM.
    </p>
  </div>
  <div class="m-25" *ngIf="isPJ">
<!--    <ul class="check-list" *ngIf="showItemAccountBusinessPJ && isPJ">-->
<!--      <li class="check-list__item">-->
<!--        <ibk-icon class="bullet">check</ibk-icon>-->
<!--        <span class="content">-->
<!--          Texto pendiente.<br />-->
<!--        </span>-->
<!--      </li>-->
<!--      <li class="check-list__item">-->
<!--        <ibk-icon class="bullet">check</ibk-icon>-->
<!--        <span class="content">-->
<!--          Texto pendiente.<br />-->
<!--        </span>-->
<!--      </li>-->
<!--    </ul>-->
    <a href="#" [ngClass]="showItemAccountBusiness?'ibk-link collapsible f-s-20':'ibk-link collapsible-active f-s-20'"
      (click)="evtYourBusinessAccountPJ($event)"><span class="text-bold">{{titleViewDetails}}</span></a>
  </div>
</section>
<!-- <div class="ba-field-group">
  <button class="ibk-btn collapsible">
    <span class="title-size-large">Ver menos</span>
  </button>
</div> -->

<hr class="ibk-separator" />

<div *ngIf="!isPJ">
  <h1 class="ibk-title text-center">Accesos a la Banca por Internet</h1>
  <ng-container formGroupName="configData">
    <h3 class="title f-regular text-center">Tu Cuenta Negocios para persona natural incluye el acceso gratuito a la APP
      Interbank y
      Banca por Internet donde podr&aacute;s realizar:</h3>

    <ul class="check-list">
      <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
          Consulta de saldos y movimientos <br />
        </span>
      </li>
      <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
          Transferencias a otras cuentas o bancos <br />
        </span>
      </li>
      <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
          Pago de tarjetas de cr&eacute;dito <br />
        </span>
      </li>
      <li class="check-list__item">
        <ibk-icon class="bullet">check</ibk-icon>
        <span class="content">
          Pago de servicios o a empresas <br />
        </span>
      </li>
    </ul>
    <div class="clarification">
      <h3 class="title f-regular text-center">Adicionalmente, puedes elegir de forma opcional tener acceso a nuestra APP
        Interbank
        Empresas
        y Banca por Internet Empresas.</h3>
    </div>
    <br />
    <section class="checkbox-group section-banca-empresas">

      <ibk-input id="authorize-personal-data">
        <input type="checkbox" formControlName="bieAccess" />
        <b class="b-title"> Banca por internet para empresas </b>
      </ibk-input>
      <br />
      <br />
      <ul class="check-list">
        <li class="check-list__item">
          <ibk-icon class="bullet">check</ibk-icon>
          <span class="content">
            Acceso a la banca por internet para empresas <br />
          </span>
        </li>
        <li class="check-list__item">
          <ibk-icon class="bullet">check</ibk-icon>
          <span class="content">
            Pagos masivos de planillas y CTS <br />
          </span>
        </li>
        <li class="check-list__item">
          <ibk-icon class="bullet">check</ibk-icon>
          <span class="content">
            Pago de letras <br />
          </span>
        </li>
        <li class="check-list__item">
          <ibk-icon class="bullet">check</ibk-icon>
          <span class="content">
            Pago de servicios <br />
          </span>
        </li>
        <li class="check-list__item">
          <ibk-icon class="bullet">check</ibk-icon>
          <span class="content">
            Cero costo <br />
          </span>
        </li>
      </ul>
    </section>
  </ng-container>
  <br /><br />
  <hr class="ibk-separator" />
</div>
